<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row">
      <div class="col">
        <nav class="nav_Breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('propertyreservation.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3">
              <router-link :to="'/propertydetails/'+this.propertyID">
                {{$t('propertyreservation.breadcrumb_2')}}
              </router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">
              {{$t('propertyreservation.breadcrumb_3')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>

  <div class="container pt-3">
    <mainloader v-if="isLoading || loading" />
    <div v-if="step == 1 && !isLoading" class="row">
      <div class="col">
        <errorAlert v-if="hasError" :alertMessage="message" />
        <div class="row pt-3 justify-content-center">
          <div class="col-12 mb-4">
            <div class="card br-radius-16">
              <div class="card-body padding-10">
                <div class="row">
                  <div class="col-6 col-md-2 button-center">
                    <div class="position-R">
                      <swiper class="width-140" v-if="item.property.mediaFiles.length" :modules="[Pagination, Navigation]" 
                        :pagination="{ clickable: true }" :navigation="false"  
                        > 
                        <swiper-slide v-for="(val, index) in rows" :key="index">
                          <img :src="MEDIA_URL+val.thumbnail" alt="Slide Image" class="img-fluid br-radius" />
                        </swiper-slide>
                      </swiper>
                      <div v-else>
                        <img src="/assets/images/defaultImage.jpg" class="img-fluid br-radius" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 button-center">
                    <div class="row">
                      <div class="col-auto">
                        <div class="reservation-style mb-2">
                          {{item.property.PropertyType.name}}
                        </div>
                      </div>
                      <div class="col-auto">
                        <!-- <span class="reservation-style">{{(item.property.purpose == 'for_rent') ? 'للايجار' : 'للبيع' }}</span> -->
                        <span class="reservation-style">{{(item.property.purpose == 'for_rent') ? $t('rent') : (item.property.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                      </div>
                    </div>
                    <div class="almarai-regular">{{ item.property.title }}</div>
                    <div class="row pt-1">
                      <div class="col-auto content-center">
                        <div class="d-flex"> 
                          <i class="fa-solid fa-location-dot gray-color"></i>
                          <div class="mx-2  gray-color fonttext-14">{{ item.property.City.name }}</div>
                          <span class="gray-color fonttext-14">{{ item.property.Neighborhood.name }}</span>
                        </div>
                      </div>
                      <div class="col-auto">
                        <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                        <span class="green-color-F">{{ item.property.price }}</span>
                        <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-3">
          <div class="col">
            <h5 class="almarai-bold">{{$t('propertyreservation.stepsCompleteRental')}}</h5>
            <div class="row pt-2">
              <div class="col-auto content-center">
                <div class="width-48">
                  <img src="/assets/images/icons/reservation-icon-1.png" class="img-fluid" alt="">
                </div>
              </div>
              <div class="col">
                <div class="almarai-bold">{{$t('propertyreservation.propertyReservation')}}</div>
                <div class="fonttext-14 gray-color almarai-regular">{{$t('propertyreservation.confirmsyour_Serious')}}</div>
                <!-- <div class="fonttext-14 gray-color almarai-regular">{{$t('propertyreservation.title_4')}}</div> -->
              </div>
            </div>
            <div class="row py-4">
              <div class="col-auto content-center">
                <div class="width-48">
                  <img src="/assets/images/icons/reservation-icon-2.png" class="w-100" alt="">
                </div>
              </div>
              <div class="col">
                <div class="almarai-bold">{{$t('propertyreservation.contractsSent')}}</div>
                <div class="fonttext-14 gray-color almarai-regular">{{$t('propertyreservation.afterReservation')}}</div>
                <!-- <div class="fonttext-14 gray-color almarai-regular">{{$t('propertyreservation.title_7')}}</div> -->
              </div>
            </div>
            <div class="row">
              <div class="col-auto content-center">
                <div class="width-48">
                  <img src="/assets/images/icons/reservation-icon-3.png" class="w-100" alt="">
                </div>
              </div>
              <div class="col">
                <div class="almarai-bold">{{$t('propertyreservation.payRent')}}</div>
                <div class="fonttext-14 gray-color almarai-regular">
                  {{$t('propertyreservation.verifyContracts')}}
                  <!-- <span class="gold-color-9E mx-1">{{$t('propertyreservation.ownershipOfficially')}}</span> -->
                </div>
                <!-- <div class="fonttext-14 gray-color almarai-regular">
                  <span class="mx-1"> {{$t('propertyreservation.title_10')}}</span>
                  <span class="mx-1">{{$t('propertyreservation.title_11')}}</span>
                </div> -->
              </div>
            </div>

            <div class="row pt-3">
              <div class="col">
                <div class="accordion" id="accordion-id" >
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseaccordion-id" aria-expanded="false" aria-controls="collapseaccordion-id">
                        <span class="ms-3">
                          <img src="/assets/images/icons/message-question.png" class="max-24" alt="">
                        </span>
                        <span class="text-center questions-text">{{$t('propertyreservation.title_14')}}</span>
                      </button>
                    </h2>
                    <div id="collapseaccordion-id" class="accordion-collapse collapse" data-bs-parent="accordion-id">
                      <div class="accordion-body">
                        <!-- <strong class="preLine">
                          {{$t('propertyreservation.title_15')}}
                        </strong><br>
                        <strong class="preLine">
                          {{$t('propertyreservation.title_16')}}
                        </strong> -->
                        <div>{{$t('propertydetails.title_23')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row pt-5">
              <div class="col">
                <div class="">
                  <input class="form-check-input" v-model="financingRequest" type="checkbox" value="" id="checkDefault">
                  <label class="form-check-label mx-3" for="checkDefault">
                    اريد شراء العقار بنظام التمويل العقاري
                  </label>
                  <div class="almarai-regular fonttext-14 gray-color me-2 pe-4">اضغط هنا اذا كنت تود شراء العقار بنظام التمويل </div>
                </div>
              </div>
            </div> -->

            <div class="row pt-5 justify-content-center">
              <div class="col-12 col-md-5 mouse-hand" @click="poupPaymentOrder">
                <div class="submit-button text-center">{{$t('propertyreservation.title_12')}}  {{totalCost}}  {{$t('propertyreservation.title_13')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="step == 2">
      <div class="col">
        <div class="row justify-content-center pt-3">
          <div class="col-12 text-center">
            <img src="/assets/images/tick-circle.png" alt="">
          </div>
        </div>
        <div class="row pt-3">
          <div class="col text-center">
            <h3 class="font-24 almarai-bold text-center mb-2">{{$t('propertyreservation.successfullyBooked')}}</h3>
            <p class="small-Font mb-1">{{$t('propertyreservation.contractswithin')}}</p>
            <p class="small-Font mb-1">{{$t('propertyreservation.realEstate_Exchange')}}</p>
            <p class="small-Font">{{$t('propertyreservation.notificationSoon')}}</p>
          </div>
        </div>
        <div class="row pt-2 justify-content-center">
          <div class="col-11 col-md-5">
            <router-link to="/">
              <div class="back almarai-bold text-center">{{$t('propertyreservation.btn_backHome')}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row" v-if="step == 2">
      <div class="col">
        <span class="mouse-hand" @click="prevStep"> 
          <i class="fa-solid fa-arrow-right"></i>
        </span>
        <h5 class="almarai-bold py-3">بيانات التمويل العقاري</h5>
        <errorAlert v-if="hasError" :alertMessage="message" />
        <div class="row">
          <div class="col">
            <label for="" class="almarai-regular fonttext-14 gray-color">الاسم بالكامل</label>
            <input type="text" v-model="fullName" class="form-control input-style" id="name">
          </div>
        </div>
        <div class="row pt-3">
          <div class="col">
            <label for="" class="almarai-regular fonttext-14 gray-color">رقم الجوال</label>
            <input type="text" v-model="mobile" class="form-control input-style" id="number">
          </div>
        </div>
        <div class="row pt-3">
          <div class="col">
            <label class="almarai-regular fonttext-14 gray-color" for="">صافي دخلك الشهري ( الراتب )</label>
            <input type="number" v-model="salary" class="form-control input-style">
          </div>
        </div>
        <div class="row pt-3">
          <div class="col">
            <label for="" class="almarai-regular fonttext-14 gray-color">اذكر الالتزامات القائمة عليك بالكامل</label>
            <textarea v-model="obligations" class="form-control br-radius-16 border-EEE" rows="4"></textarea>
          </div>
        </div>

        <div class="row pt-5 justify-content-center">
          <div class="col-10 mouse-hand" @click.prevent="propertyReservationFN">
            <div class="text-center submit-button">تقديم طلب تمويل عقاري</div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div v-if="!loader && step == 3" class="row pt-5">
      <div class="col">
        <div class="mouse-hand" @click="prevStep"> 
          <i class="fa-solid fa-arrow-right"></i>
        </div>
        <div class="almarai-bold py-4">
          <router-link to="/addpaymentcard">
            <i class="fa-solid fa-circle-plus orange-color"></i>
            <span class="mx-2">اضف بطاقتك للدفع</span>
          </router-link>
        </div>
        <errorAlert v-if="hasError" :alertMessage="message" />
        <div class="row py-2">
          <div class="col-12 mb-2" v-for="(val,index) in cards" :key="index">
            <div class="form-check input-style position-R">
              <label class="form-check-label" :for="val.id">
                {{val.last}}-****-****-****
                <input class="form-check-input check-radio" v-model="cardId" :value="val.id" name="radioDefault" type="radio"  :id="val.id">
              </label>
            </div>
          </div>
        </div>
        <div class="row py-2">
          <div class="col-12">
            <label for="" class="fonttext-14 gray-color">الـ CVV
              <span class="orange-color">*</span>
            </label>
            <input type="password" class="form-control input-style" v-model="password">
          </div>
        </div>

        <div class="row pt-5 justify-content-center">
          <div class="col-10 mouse-hand" @click="propertyReservationFN">
            <div v-if="submitLoading" class="text-center">
              <loader />
            </div>
            <div v-else class="text-center submit-button">حجز العقار بـ {{value.price}} الاف ريال</div>
          </div>
        </div>
      </div>
    </div> -->

    <!--begin:bookingSuccessful-->
    <!-- <div class="row pt-3" v-if="step == 4">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div><img src="/assets/images/tick-circle.png" class="img-fluid" alt=""></div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col text-center">
            <h4 class="almarai-bold font-24">تم حجز العقار بنجاح!</h4>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col gray-color text-center almarai-regular">
            <div>سنعمل على تجهيز العقود في خلال الـ48 ساعه</div>
            <div>القادمة، عبر البورصة العقارية</div>
            <div>وسنرسل لك اشعار بمجرد الانتهاء</div>
          </div>
        </div>

        <div class="row pt-5 justify-content-center">
          <div class="col-10">
            <router-link to="/">
              <div class="submit-button text-center almarai-bold">الذهاب للرئيسية</div>
            </router-link>
          </div>
        </div>
        
      </div>
    </div> -->
    <!--end:bookingSuccessful-->

    <!-- begin:modal-payment -->
    <!-- <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="paymentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          
          <div class="modal-body">
            <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/Frame_41.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_14')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/img-3.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_16')}}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row pt-5 justify-content-center">
              <div class="col text-center">
                <button @click.prevent="paymentMethod" class="form-control padding-style almarai-bold buttonStyle">{{$t('maintenanceDetails.title_5')}} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- end:modal-payment -->

    <!-- begin:modal-payment -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="documentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3" v-if="totalCost">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{(hasCoupon)? newDiscount : totalCost}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                    <span class="bankCard">{{$t('wallet.bankCard')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                    <span class="bankCard">{{$t('wallet.appWallet')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <loader v-if="paymentLoading" class="text-center" />
              <div v-else class="col-12 col-md-9 text-center">
                <div @click.prevent="paymentMethod" class="btn-green">{{$t('maintenanceDetails.title_5')}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->


    <!--begin:popup wallet balance -->
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount === null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{totalCost}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                <del>{{totalCost}}</del>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null || discountPercentage">
              <div class="col-auto almarai-bold content-center">{{$t('priceDiscount')}}</div>
              <div class="col text-start">
                {{newDiscount}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{remainingBalance}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="min_loader" class="text-center">
                <loader />
              </div>
              <div v-else class="col-11 text-center" @click.prevent="propertyReservationFN">
                <div class="btn-green">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:popup wallet balance -->

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col">
                <router-link to="/wallet">
                  <div class="btn-green fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { useVuelidate } from '@vuelidate/core';
// import { required } from '@vuelidate/validators';
import { mapGetters } from "vuex";
export default {
  name: 'propertyreservation',
  setup(){
    return {
      Pagination,
      Navigation,
      validate: useVuelidate()
    }
  },
  data(){
    return{
      propertyID: this.$route.params.id,
      coupon: this.$route.query.coupon,
      step: 1,
      hasError: false,
      message: "",
      isLoading: true,
      loading: false,
      rows: [],
      item: {},
      financingRequest: false,
      fullName: "",
      mobile: "",
      salary: null,
      obligations: "",
      cardNumber: "",
      password: "",
      cards: [],
      cardId: null,
      validateMessage: this.$t('validateMessage'),
      alertError: false,
      submitLoading: false,
      value: {},
      paymentGate: "",
      min_loader: false,
      totalCost: 0,
      remainingBalance: 0,
      userLang: 'ar',
      hasCoupon: false,
      newDiscount: null,
      discountPercentage: null,
      amount: null,
      paymentLoading: false,
    }
  },
  validations (){
    return {
      // propertyID: {required},
      // cardId: {required},
      // password: {required},
    }
  },
  components: { Swiper, SwiperSlide },
  computed:{
    ...mapGetters(['MEDIA_URL', 'USER_WALLET_BALANCE'])
  },
  
  methods:{
    getRetrieve(){
      this.hasError = false;
      this.$http.get("/api/properties/retrieve/"+this.propertyID).then(async res => {
        // console.log(res);
        this.item = res.data;
        this.rows = this.item.property.mediaFiles;
        // this.totalCost = res.data.property.price;
        this.getPrice();
        this.isLoading = false;
        console.log(this.totalCost);
        
        window.scroll(0,0);
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
      })
    },

    propertyReservationFN(){
      this.hasError = false;
      this.submitLoading = true;
      this.min_loader = true;

      // if(this.financingRequest && this.step == 1){
      //   this.step = 2;
      //   window.scroll(0,0);
      //   return false;
      // }
      this.$http.post("/api/propReservation/create",{
        propertyId: parseInt(this.propertyID),
        paymentMethodId: this.cardId,
        cvv: this.password,
        financingRequest: this.financingRequest,
        paymentGate: this.paymentGate,
        coupon: this.coupon,
      }).then(res => {
        // console.log(res);
        if(res.data.paymentUrl){
          window.location.href = res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            this.closeWalletBalance();
          }
          this.step = 2;
        }
        this.submitLoading = false;
        this.min_loader = false;
      }).catch(err => {
        // console.log(err);
        this.submitLoading = false;
        this.min_loader = false;
        this.message = this.$globalError(err);
        this.hasError = true;
        window.scroll(0,0);
      });
    },

    // nextStep(){
    //   if(!this.financingRequest){
    //     this.step = 3;
    //     return false;
    //   }
    //   this.step += 1;
    // },
    prevStep(){
      this.step -= 1;
      if(!this.financingRequest){
        this.step =1;
      }
    },
    getPrice(){
      this.$http.get("/api/propReservation/init").then(res => {
        // console.log(res);
        this.value = res.data;
        this.totalCost = this.value.price;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
        window.scroll(0,0);
      })
    },

    poupPaymentOrder(){
      if(this.hasCoupon && this.discountPercentage == 'percentage' && this.amount == 100){
        this.propertyReservationFN();
        return false;
      }
      document.getElementById('selectPayment').click();
    },

    showPopup(){
      document.getElementById('selectPayment').click();
      if(this.totalCost > this.USER_WALLET_BALANCE){
        document.getElementById('chargeWallet').style.display = 'block';
      }else{
        this.remainingBalance =  this.USER_WALLET_BALANCE - this.totalCost;
        document.getElementById('popup_WalletBalance').style.display = 'block';
      }
    },

    paymentMethod(){
      if(this.paymentGate == 'online'){
        this.propertyReservationFN();
      }else{
        this.showPopup();
      }
    },

    closeWalletBalance(){
      document.getElementById('popup_WalletBalance').style.display = 'none';
    },

    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    },
    checkProperty(){
      this.loading = true;
      this.$http.post('/api/coupons/checkProperty',{
        propertyId: parseInt(this.propertyID),
        coupon: this.coupon
      }).then(res => {
        // console.log(res);
        this.amount = res.data.row.amount;
        this.discountPercentage = res.data.row.discountType;
        if(this.discountPercentage == 'percentage'){
          console.log('percentage');
          console.log(this.totalCost);
          this.newDiscount = this.totalCost - ((this.totalCost * this.amount) /100);
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }else{
          console.log('fixed');
          this.newDiscount = this.totalCost - this.amount;
          if(this.newDiscount < 0)
            this.newDiscount = 0;
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }
        this.hasCoupon = true;
        this.loading = false;
        console.log('sssss');
        console.log(this.newDiscount);
        
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.loading = false;
      })
    },
  },
  created(){
    this.getRetrieve();
    // if(this.coupon){
    //   this.checkProperty();
    // }
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>